//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteNDN from './expedienteNotasDN'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteNDN />
            </div>
        );
    }

}
export default Index;